<template>
  <svg
    :width="width ? width : height ? height * (12 / 14) : 12"
    :height="height ? height : width ? width * (14 / 12) : 14"
    viewBox="0 0 12 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M.1193 1.1086L.6664 8.321c.0337.4462.583.64.8883.3126L3.905 6.113l4.4855 4.1668a1.28 1.28 0 0 1 .4088.9333l.0076 2.1498a.64.64 0 0 0 .641.6377l1.7993-.003a.64.64 0 0 0 .639-.6384l.008-3.1174a1.92 1.92 0 0 0-.6037-1.4027L6.0048 3.8614l2.3504-2.5205c.305-.327.0742-.8614-.3738-.8643L.6244.4332a.3144.3144 0 0 0-.072.0079l.0139.061a.5774.5774 0 0 0-.447.6065z"
      :fill="iconColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'slightyleft',
  props: {
    iconColor: {
      type: String,
      default: '#F94094',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
